import { FormlyFieldConfig } from '@ngx-formly/core';
import { LuFormlyBuilder } from '../formly.builder';
import { BulkCheckboxOptions, FieldType, ValueLabel } from './formly-builder.models';

export class LuFormlyMulticheckboxBuilder extends LuFormlyBuilder {
	protected type = FieldType.MULTICHECKBOX;
	private options: ValueLabel[];
	private parsers: ((value: any) => {})[];
	private templateOptionsType: string;
	private bulkSelectOptions: BulkCheckboxOptions;

	constructor(key: string, options: ValueLabel[], label: string, className?: string) {
		super(key, label, null, className);
		this.options = options;
	}

	setTemplateOptionsType(templateOptionsType: string): this {
		// https://github.com/ngx-formly/ngx-formly/issues/1599
		this.templateOptionsType = templateOptionsType;
		return this;
	}

	setParser(parsers: ((value: any) => {})[]): this {
		this.parsers = parsers;
		return this;
	}

	setBulkSelectOptions(bulkSelectOptions: BulkCheckboxOptions): this {
		this.bulkSelectOptions = bulkSelectOptions;
		return this;
	}

	public build(): FormlyFieldConfig {
		const field = super.build();

		field.templateOptions.options = this.options.map(item => {
			const { label, value, disabled } = item;
			return {
				label,
				value,
				disabled: !!disabled
			};
		});

		if (!!this.templateOptionsType) {
			field.templateOptions.type = this.templateOptionsType;
		}

		if (this.bulkSelectOptions) {
			field.templateOptions.bulkSelectOptions = this.bulkSelectOptions;
		}

		field.parsers = this.parsers;

		return field;
	}
}
